/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Marki`
};

const da_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Mærke`
};

const de_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Marke`
};

const en_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Brand`
};

const es_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Marca`
};

const fr_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Marque`
};

const hu_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Márka`
};

const it_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Marchio`
};

const nl_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Merk`
};

const pl_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Marka`
};

const pt_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Marca`
};

const sv_attributes_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Varumärke`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_brand = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_brand(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_brand", locale)
	if (locale === "cs") return cs_attributes_brand(inputs)
	if (locale === "da") return da_attributes_brand(inputs)
	if (locale === "de") return de_attributes_brand(inputs)
	if (locale === "en") return en_attributes_brand(inputs)
	if (locale === "es") return es_attributes_brand(inputs)
	if (locale === "fr") return fr_attributes_brand(inputs)
	if (locale === "hu") return hu_attributes_brand(inputs)
	if (locale === "it") return it_attributes_brand(inputs)
	if (locale === "nl") return nl_attributes_brand(inputs)
	if (locale === "pl") return pl_attributes_brand(inputs)
	if (locale === "pt") return pt_attributes_brand(inputs)
	return sv_attributes_brand(inputs)
};
export { attributes_brand as "attributes.brand" }